import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';

import { SupabasePrototype } from './SupabasePrototype';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { Login } from './components/auth/Login';

const AuthWrapper = () => {
  const { currentUser, loading } = useAuth();
  
  if (loading) {
    return <div className="min-h-screen bg-[#110a10] text-[#ff154d] flex items-center justify-center font-bold" style={{ fontFamily: "'Oxanium', sans-serif" }}>Zeyo✧</div>;
  }
  
  if (!currentUser) {
    return <Login />;
  }
  
  return <SupabasePrototype />;
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <AuthWrapper />
    </AuthProvider>
  </React.StrictMode>
);

// Register service worker for PWA offline capabilities
serviceWorker.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

